import { ApplicationConfig, importProvidersFrom, LOCALE_ID, isDevMode } from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { IdeaApiModule, IdeaLoaderModule } from '@ideatech/ngx-ideatech';
import { environment } from '../environments/environment';
import { authenticationInterceptor } from './core/interceptors/authentication.interceptor';
import { TranslocoHttpLoader } from './core/utils/transloco-loader';
import { provideTransloco } from '@jsverse/transloco';
import { NgbDateAdapter, NgbDateParserFormatter, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { VegaDateParserFormatter } from './core/utils/vega-date-parser-formatter';
import { VegaDateAdapter } from './core/utils/vega-date-adapter';
import { VegaModalConfig } from './core/utils/vega-modal-config';
import { loaderInterceptor } from './core/interceptors/loader.interceptor';

export const appConfig: ApplicationConfig = {
    providers: [
        { provide: NgbDateParserFormatter, useClass: VegaDateParserFormatter },
        { provide: NgbDateAdapter, useClass: VegaDateAdapter },
        { provide: NgbModalConfig, useClass: VegaModalConfig },
        { provide: LOCALE_ID, useValue: 'it-IT' },
        provideRouter(routes, withInMemoryScrolling({
            scrollPositionRestoration: 'top'
        }), withComponentInputBinding()),
        provideHttpClient(withInterceptors([authenticationInterceptor, loaderInterceptor])),
        provideAngularSvgIcon(),
        importProvidersFrom([
            IdeaApiModule.forRoot(null, { environment }),
            IdeaLoaderModule.forRoot()
        ]),
        provideTransloco({
            config: {
                availableLangs: ['en', 'it', 'fr'],
                defaultLang: 'it',
                fallbackLang: 'en',
                reRenderOnLangChange: true,
                prodMode: !isDevMode(),
            },
            loader: TranslocoHttpLoader
        })
    ],
};
